import { Subscription , of } from 'rxjs';
import { AuthServer } from '@services/auth-server.service';
import { ChartService } from './../../services/webFeeder/sckt-chart.service';
import { Component, OnInit, Input, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Constants } from '@utils/constants';
import { WorkspaceNewService } from '@services/workspace-new.service';
import { AbstractItemService } from '@business/base/abstract-item.service';
import { AbstractItem } from '@business/base/abstract-item';
import { ConfigService } from '@services/webFeeder/config.service';
import { ConnectTypeUperEnum } from '@model/enum/connect-type-user.enum';
import { ConfigCardsModel } from '@model/config-comp-settings.model';
import { DailyOrderService } from '@services/webFeeder/sckt-daily-order.service';

@Component({
  selector: Constants.WINDOW_NAME_QUOTE_CHART,
  templateUrl: './quote-chart.component.html'
})
export class QuoteChartComponent extends AbstractItem implements OnInit, OnDestroy {
  protected override workspaceService: WorkspaceNewService;
  symbol: string;
  interval: '1D';
  timeframe: '1m';
  windowActive: any;
  @Input() override data: any;
  @ViewChild('quoteChart') quoteChartEl: ElementRef;
  showExpandCard: boolean;
  removeFromWksTooltip = Constants.TOOLTIP_REMOVE_WKS_TOOL;
  toolTipEngine = Constants.TOOLTIP_ENGINE;
  showTradeChart = false;
  loadingStrategies = true;
  strategiesList = [];
  orderStrategy = 'DAYTRADE';
  whiteLabel: any;
  isMarketData = this.configService.isLoginMarketData();
  subscriptionHbLoginType: Subscription;
  showConfirmation = false;
  hiddenConfirmationBillet = false;

  constructor(
    workspaceService: WorkspaceNewService,
    dialog: MatDialog,
    itemService: AbstractItemService,
    private configService: ConfigService,
    private chartService: ChartService,
    private authServer: AuthServer,
    private _dailyOrderService: DailyOrderService,
  ) {
    super(workspaceService, dialog, itemService);
    this.showExpandCard = this.configService.getShowExpandCard(Constants.WINDOW_NAME_QUOTE_CHART);
    this.whiteLabel = this.configService.getConfigWhitelabel();
  }

  ngOnInit() {
    const configQuoteChar = this.configService.getCookieConfigCards(this.data.type);
    if (configQuoteChar && configQuoteChar.length >= 0) {
      const indexTemp = configQuoteChar.findIndex(x => x.quoteChartId === this.data.id);
      if (indexTemp >= 0) {
        this.hiddenConfirmationBillet = configQuoteChar[indexTemp].quoteChartHiddenConfirmation;
      }
    } else {
      this.saveConfigCard(this.data.type, this.data.id, this.hiddenConfirmationBillet);
    }
    this.subscriptionHbLoginType = this.configService.authHbLoginType$.subscribe(isMarketData => {
      if (isMarketData === ConnectTypeUperEnum.HB_TYPE_MARKET_DATA) {
        this.isMarketData = true;
        this.showTradeChart = false;
      }
    });

    this.symbol = this.data.symbol;
    this.getStrategies();
  }

  toggleConfirmationBillet(state) {
    this.showConfirmation = state;
  }

  onSymbolChange(newSymbol) {
    if (this.symbol.toLowerCase().trim() !== newSymbol.toLowerCase().trim()) {
      super.updateOnDemand(null, newSymbol);
      this.symbol = newSymbol;
    }
  }

  getStrategies() {
    this.loadingStrategies = true;
    this.authServer.iNegotiation.getStrategies()
      .subscribe(res => {
        this.strategiesList = [...res];
        if (this.strategiesList && this.strategiesList.length >= 2) {
          const defaultStrategy = this.strategiesList.findIndex(strategy => strategy.orderStrategy === this.whiteLabel.billet.orderStrategy);
          this.orderStrategy = defaultStrategy !== -1 ? this.strategiesList[defaultStrategy].orderStrategy : null;
        }
        this.loadingStrategies = false;
      }, () => {
        this.loadingStrategies = false;
      });
  }

  changeStrategy(newStrategy) {
    this.orderStrategy = newStrategy;
  }

  openNewWindow() {
    const options = 'width=1203px, height=768';
    const parameters = '?symbol=' + this.symbol + '&chartid=' + this.chartService.getNewChartId();
    if (this.windowActive == null || this.windowActive.closed) {
      super.getNewWindow('chart', parameters, options, this.data.id)
        .subscribe(window => {
          this.windowActive = window;
        });
    } else {
      this.windowActive.focus();
    }
  }

  ngOnDestroy() {
    this.closeSheet();
    this.subscriptionHbLoginType.unsubscribe();
  }

  closeSheet() {
    if (this.windowActive != null) {
      this.windowActive.close();
    }
  }

  stopPropagation() {
    event.stopPropagation();
  }

  showHiddenConfirmationBilliet() {
    this.hiddenConfirmationBillet = !this.hiddenConfirmationBillet;
    this.saveConfigCard(this.data.type, this.data.id, this.hiddenConfirmationBillet);
  }

  saveConfigCard(componentName: string, quoteChartId: number, quoteChartHiddenConfirmation: boolean) {
    const configCards: ConfigCardsModel = { quoteChartId: quoteChartId, quoteChartHiddenConfirmation: quoteChartHiddenConfirmation, };
    this.configService.setCookieConfigCards(componentName, configCards);
  }

}
